import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';


export default createStore({
    plugins: [createPersistedState()],
    state: {
        openSidebarPrimary: false,
        hoverSidebarPrimary: false,
        token: null,
        refreshToken: null,
        user: null,
        isVisibleSideBarGenericModal: false,
        isVisibleModalUser: false,
        fieldsModalGeneric: [],
        currentCrew: null,
        currentRunIa: null,
        userInfoData: null,
        crewsList: [],
        currentCrewHistory: null,
        ordersHistory: [],
        orderByCrewsHistory: [],
        favoriteOrdersHistory: []
    },
    mutations: {
        setOpenSidebarPrimary(state, isOpen) {
            state.openSidebarPrimary = isOpen;
        },
        setHoverSidebarPrimary(state, isHover) {
            state.hoverSidebarPrimary = isHover;
        },
        setToken(state, token) {
            state.token = token;
        },
        setRefreshToken(state, refreshToken) {
            state.refreshToken = refreshToken;
        },
        setUser(state, user) {
            state.user = user;
        },
        setIsVisibleSideBarGenericModal(state, isVisibleSideBarGenericModal) {
            state.isVisibleSideBarGenericModal = isVisibleSideBarGenericModal;
        },
        setFieldsModalGeneric(state, fields) {
            state.fieldsModalGeneric = fields;
        },
        setCurrentCrew(state, currentCrew) {
            state.currentCrew = currentCrew;
        },
        setCurrentRunIa(state, currentRunIa) {
            state.currentRunIa = currentRunIa;
        },
        setIsVisibleModalUser(state, isVisibleModalUser) {
            state.isVisibleModalUser = isVisibleModalUser;
        },
        setUserInfoData(state, userInfoData) {
            state.userInfoData = userInfoData;
        },
        setCrewsList(state, crewsList) {
            state.crewsList = crewsList;
        },
        setCurrentCrewHistory(state, currentCrewHistory) {
            state.currentCrewHistory = currentCrewHistory;
        },
        setOrdersHistory(state, ordersHistory) {
            state.ordersHistory = ordersHistory;
        },
        setOrderByCrewsHistory(state, orderByCrewsHistory) {
            state.orderByCrewsHistory = orderByCrewsHistory;
        },
        setFavoriteOrdersHistory(state, favoriteOrdersHistory) {
            state.favoriteOrdersHistory = favoriteOrdersHistory;
        }
    },
    actions: {
        storeSidebarPrimary({ commit }, payload) {
            commit('setOpenSidebarPrimary', payload.openSidebarPrimary);
        },
        storeHoverSidebarPrimary({ commit }, payload) {
            commit('setHoverSidebarPrimary', payload.hoverSidebarPrimary);
        },
        storeToken({ commit }, payload) {
            commit('setToken', payload.token);
        },
        storeRefreshToken({ commit }, payload) {
            commit('setRefreshToken', payload.refreshToken);
        },
        storeUser({ commit }, payload) {
            commit('setUser', payload.user);
        },
        storeIsVisibleSideBarGenericModal({ commit }, payload) {
            commit('setIsVisibleSideBarGenericModal', payload.isVisibleSideBarGenericModal);
        },
        storeFieldsModalGeneric({ commit }, payload) {
            commit('setFieldsModalGeneric', payload.fields);
        },
        storeCurrentCrew({ commit }, payload) {
            commit('setCurrentCrew', payload.currentCrew);
        },
        storeCurrentRunIa({ commit }, payload) {
            commit('setCurrentRunIa', payload.currentRunIa);
        },
        storeIsVisibleModalUser({ commit }, payload) {
            commit('setIsVisibleModalUser', payload.isVisibleModalUser);
        },
        storeUserInfoData({ commit }, payload) {
            commit('setUserInfoData', payload.userInfoData);
        },
        storeCrewsList({ commit }, payload) {
            commit('setCrewsList', payload.crewsList);
        },
        storeCurrentCrewHistory({ commit }, payload) {
            commit('setCurrentCrewHistory', payload.currentCrewHistory);
        },
        storeOrdersHistory({ commit }, payload) {
            commit('setOrdersHistory', payload.ordersHistory);
        },
        storeOrderByCrewsHistory({ commit }, payload) {
            commit('setOrderByCrewsHistory', payload.orderByCrewsHistory);
        },
        storeFavoriteOrdersHistory({ commit }, payload) {
            commit('setFavoriteOrdersHistory', payload.favoriteOrdersHistory);
        }
    }
});
